import { render, staticRenderFns } from "./flowList.vue?vue&type=template&id=006dab13"
import script from "./flowList.vue?vue&type=script&lang=js"
export * from "./flowList.vue?vue&type=script&lang=js"
import style0 from "./flowList.vue?vue&type=style&index=0&id=006dab13&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports